'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _UserConstants = require('./User-constants');

var _UserConstants2 = _interopRequireDefault(_UserConstants);

var _StorageProxy = require('../lib/StorageProxy');

var _StorageProxy2 = _interopRequireDefault(_StorageProxy);

var _stringUtils = require('../helper/stringUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLATFORM_AUTH_TOKEN = process.env.PLATFORM_AUTH_TOKEN || (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.PLATFORM_AUTH_TOKEN; /**
                                                                                                                                                                                        * NOTE: Based on API defined by Platform UI's User object
                                                                                                                                                                                        * https://github.com/Unified/platform-ui/blob/46faf48/apps/shared/lib/user.js
                                                                                                                                                                                        */

var USER_PARENT_COMPANY_ID = process.env.USER_PARENT_COMPANY_ID || (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.USER_PARENT_COMPANY_ID;

var USER_IDENTITY_ID = process.env.USER_IDENTITY_ID || (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.USER_IDENTITY_ID;

var cookieStorage = new _StorageProxy2.default(_StorageProxy.StorageType.COOKIE_STORAGE);

// the global variable is available after calling platform-ui global.js endpoint
var globalValue = function globalValue(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.unifiedGlobal && window.unifiedGlobal[key] || defaultValue;
};

var getCookieOrGlobalValue = function getCookieOrGlobalValue(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return cookieStorage.getItem(key) || globalValue(key) || defaultValue;
};

/** Class representing an Unified Platform user */

var User = function () {
  function User() {
    (0, _classCallCheck3.default)(this, User);
  }

  (0, _createClass3.default)(User, null, [{
    key: '_getEncodedValue',

    /**
     * Get encoded value from cookie
     * @param {string} key Cookie name to get value
     */
    value: function _getEncodedValue(key) {
      var value = cookieStorage.getItem(key);

      return value ? JSON.parse(window.atob(value)) : null;
    }

    /**
     * Get authentication token for user
     * @static
     * @return {string} Unified Platform authentication token
     */

  }, {
    key: 'authToken',
    value: function authToken() {
      return getCookieOrGlobalValue(_UserConstants2.default.TOKEN_COOKIE, PLATFORM_AUTH_TOKEN);
    }

    /**
     * Get identity ID for user
     * @static
     * @return {string} Unified Platform identity ID
     */

  }, {
    key: 'identityId',
    value: function identityId() {
      if (User.isTemp()) return getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_EMAIL_COOKIE);

      return getCookieOrGlobalValue(_UserConstants2.default.IDENTITY_ID_COOKIE, USER_IDENTITY_ID);
    }

    /**
     * Get current user's id. It considers impersonanting.
     */

  }, {
    key: 'currentUserId',
    value: function currentUserId() {
      if (User.isTemp()) return getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_EMAIL_COOKIE);

      var impersonating = User.impersonating();

      return impersonating[_UserConstants2.default.IMPERSONATE_IDENTITY_ID] || User.identityId();
    }

    /**
     * Get impersonated user
     * @static
     * @return {string} Email address of impersonated Unified Platform user
     */

  }, {
    key: 'impersonating',
    value: function impersonating() {
      if (User.isTemp()) return {};

      return User._getEncodedValue(_UserConstants2.default.USER_IMPERSONATING_COOKIE) || globalValue(_UserConstants2.default.USER_IMPERSONATING_COOKIE, {});
    }

    /**
     * Get admin status for user
     * @static
     * @return {boolean} Is user an Unified Platform admin?
     */

  }, {
    key: 'isAdmin',
    value: function isAdmin() {
      if (User.isTemp()) return false;

      return (0, _stringUtils.convertToBoolean)(getCookieOrGlobalValue(_UserConstants2.default.IS_ADMIN_COOKIE));
    }

    /**
     * Get provider admin status for user
     * @static
     * @return {boolean} Is user an Unified Platform provider admin?
     */

  }, {
    key: 'isProviderAdmin',
    value: function isProviderAdmin() {
      if (User.isTemp()) return false;

      return (0, _stringUtils.convertToBoolean)(getCookieOrGlobalValue(_UserConstants2.default.IS_PROVIDER_ADMIN_COOKIE));
    }
  }, {
    key: 'isTemp',
    value: function isTemp() {
      return !!getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_EMAIL_COOKIE);
    }
  }, {
    key: 'tempUserInvitor',
    value: function tempUserInvitor() {
      if (!User.isTemp()) return null;

      return getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_INVITOR_COOKIE);
    }
  }, {
    key: 'tempUserBrand',
    value: function tempUserBrand() {
      if (!User.isTemp()) return null;

      return getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_BRAND_COOKIE);
    }

    /**
     * Get default currency for user
     * @static
     * @return {string} Currency type
     */

  }, {
    key: 'defaultCurrency',
    value: function defaultCurrency() {
      return getCookieOrGlobalValue(_UserConstants2.default.USER_CURRENCY_COOKIE);
    }

    /**
     * Get timezone for user
     * @static
     * @return {string} Timezone
     */

  }, {
    key: 'timezone',
    value: function timezone() {
      return getCookieOrGlobalValue(_UserConstants2.default.USER_TIMEZONE_COOKIE);
    }

    /**
     * Get email address for user
     * @static
     * @return {string} Email address
     */

  }, {
    key: 'email',
    value: function email() {
      if (User.isTemp()) return getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_EMAIL_COOKIE);

      return getCookieOrGlobalValue(_UserConstants2.default.USER_EMAIL_COOKIE);
    }

    /**
     * Get organization role title for user
     * @static
     * @return {string} Organization role title
     */

  }, {
    key: 'title',
    value: function title() {
      if (User.isTemp()) return 'Temporary User';

      return getCookieOrGlobalValue(_UserConstants2.default.USER_TITLE_COOKIE);
    }

    /**
     * Get organization role title type for user
     * @static
     * @return {string} Organization role title type
     */

  }, {
    key: 'titleType',
    value: function titleType() {
      if (User.isTemp()) return 'Temporary';

      return getCookieOrGlobalValue(_UserConstants2.default.USER_TITLE_TYPE_COOKIE);
    }

    /**
     * Get creation date for user
     * @static
     * @return {string} Date user was created on Unified Platform
     */

  }, {
    key: 'createDate',
    value: function createDate() {
      return getCookieOrGlobalValue(_UserConstants2.default.USER_CREATE_DATE_COOKIE);
    }

    /**
     * Get name for user
     * @static
     * @return {object} Object with firstName & lastName
     */

  }, {
    key: 'userName',
    value: function userName() {
      if (User.isTemp()) {
        return User.firstName() + ' ' + User.lastName();
      }

      var o = User._getEncodedValue(_UserConstants2.default.USER_NAME_COOKIE) || globalValue(_UserConstants2.default.USER_NAME_COOKIE, null);

      if (o) {
        if (o.firstName) o.firstName = decodeURIComponent(o.firstName);
        if (o.lastName) o.lastName = decodeURIComponent(o.lastName);
      }

      return o;
    }

    /**
     * Get first name for user
     * @static
     * @return {string} First name
     */

  }, {
    key: 'firstName',
    value: function firstName() {
      if (User.isTemp()) return decodeURIComponent(getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_FIRST_NAME_COOKIE));

      var userName = User.userName();

      return userName && userName.firstName;
    }

    /**
     * Get last name for user
     * @static
     * @return {string} Last name
     */

  }, {
    key: 'lastName',
    value: function lastName() {
      if (User.isTemp()) return decodeURIComponent(getCookieOrGlobalValue(_UserConstants2.default.TEMP_USER_LAST_NAME_COOKIE));

      var userName = User.userName();

      return userName && userName.lastName;
    }

    /**
     * Get parent company for user. First checks if user is impersonating.
     * @static
     * @return {object} Object with id & name
     */

  }, {
    key: 'parentCompany',
    value: function parentCompany() {
      // Temp users inherit the permissions from the inviting company, so this is important
      if (User.isTemp()) return User._getEncodedValue(_UserConstants2.default.USER_COMPANY_COOKIE);

      var impersonatingCompany = User.impersonating().parentCompany;

      var o = impersonatingCompany || User._getEncodedValue(_UserConstants2.default.USER_COMPANY_COOKIE) || globalValue(_UserConstants2.default.USER_COMPANY_COOKIE, null);

      if (o && o.name) o.name = decodeURIComponent(o.name);

      return o;
    }

    /**
     * Get ID for user's parent company. First checks if user is impersonating.
     * @static
     * @return {string} Company ID
     */

  }, {
    key: 'parentCompanyId',
    value: function parentCompanyId() {
      var parentCompany = User.parentCompany();

      return parentCompany && parentCompany.id || USER_PARENT_COMPANY_ID;
    }

    /**
     * Get name for user's parent company. First checks if user is impersonating.
     * @static
     * @return {string} Company name
     */

  }, {
    key: 'parentCompanyName',
    value: function parentCompanyName() {
      var parentCompany = User.parentCompany();

      return parentCompany && parentCompany.name;
    }

    /**
     * Get creation date for user's parent company. First checks if user is impersonating.
     * @static
     * @return {string} Date company was created on Unified Platform
     */

  }, {
    key: 'parentCompanyCreateDate',
    value: function parentCompanyCreateDate() {
      var parentCompany = User.parentCompany();

      return parentCompany && parentCompany.createDate;
    }

    /**
     * Get is customer for user's parent company
     * @static
     * @return {boolean} Is Customer
     */

  }, {
    key: 'parentCompanyIsCustomer',
    value: function parentCompanyIsCustomer() {
      var parentCompany = User.parentCompany();

      return !!parentCompany && (0, _stringUtils.convertToBoolean)(parentCompany.isCustomer);
    }

    /**
     * Get type for user's parent company
     * @static
     * @return {string} company type
     */

  }, {
    key: 'parentCompanyType',
    value: function parentCompanyType() {
      var parentCompany = User.parentCompany();

      return parentCompany && parentCompany.type;
    }

    /**
     * Get company for user. Ignores impersonating
     * @static
     * @return {object} Object with id & name
     */

  }, {
    key: 'company',
    value: function company() {
      // Temp users inherit the permissions from the inviting company, so this is important
      if (User.isTemp()) return User._getEncodedValue(_UserConstants2.default.USER_COMPANY_COOKIE);

      var o = User._getEncodedValue(_UserConstants2.default.USER_COMPANY_COOKIE) || globalValue(_UserConstants2.default.USER_COMPANY_COOKIE, null);

      if (o && o.name) o.name = decodeURIComponent(o.name);

      return o;
    }

    /**
     * Get ID for user's company. Ignores impersonating
     * @static
     * @return {string} Company ID
     */

  }, {
    key: 'companyId',
    value: function companyId() {
      var company = User.company();

      return company && company.id || USER_PARENT_COMPANY_ID;
    }

    /**
     * Get name for user's company. Ignores impersonating
     * @static
     * @return {string} Company name
     */

  }, {
    key: 'companyName',
    value: function companyName() {
      var company = User.company();

      return company && company.name;
    }

    /**
     * Get creation date for user's company. Ignores impersonating
     * @static
     * @return {string} Date company was created on Unified Platform
     */

  }, {
    key: 'companyCreateDate',
    value: function companyCreateDate() {
      var company = User.company();

      return company && company.createDate;
    }

    /**
     * Get is customer for user's company. Ignores impersonating
     * @static
     * @return {boolean} Is Customer
     */

  }, {
    key: 'companyIsCustomer',
    value: function companyIsCustomer() {
      var company = User.company();

      return !!company && (0, _stringUtils.convertToBoolean)(company.isCustomer);
    }

    /**
     * Get type for user's company. Ignores impersonating
     * @static
     * @return {string} company type
     */

  }, {
    key: 'companyType',
    value: function companyType() {
      var company = User.company();

      return company && company.type;
    }

    /**
     * Get admin nav list for the user. Return null if not exist.
     * @static
     * @return {array} list of admin nav links
     */

  }, {
    key: 'adminNavList',
    value: function adminNavList() {
      return globalValue(_UserConstants2.default.ADMIN_NAV_LIST);
    }

    /**
     * Get admin nav list for the user. Return null if not exist.
     * @static
     * @return {array} list of admin nav links
     */

  }, {
    key: 'appNavList',
    value: function appNavList() {
      return globalValue(_UserConstants2.default.APP_NAV_LIST);
    }

    /**
     * Get admin nav list for the user.  Return null if not exist.
     * @static
     * @return {array} list of admin nav links
     */

  }, {
    key: 'userNavList',
    value: function userNavList() {
      return globalValue(_UserConstants2.default.USER_NAV_LIST);
    }

    /**
     * Get launch darkly client side id
     * @static
     */

  }, {
    key: 'ldClientSideId',
    value: function ldClientSideId() {
      return globalValue(_UserConstants2.default.LD_CLIENT_SIDE_ID);
    }
  }, {
    key: 'platformConfig',
    value: function platformConfig() {
      return globalValue(_UserConstants2.default.PLATFORM_CONFIG);
    }

    /**
     * Get the value from the global configuration by the key. It's a fallback function by which you can get the value for any key.
     * @static
     * @param {string} key
     */

  }, {
    key: 'globalConfig',
    value: function globalConfig(key, defaultValue) {
      return globalValue(key, defaultValue);
    }
  }]);
  return User;
}();

exports.default = User;
//# sourceMappingURL=User.js.map